// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qezDWa {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.t0egR6 {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.UtywbU {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.WIeLZB {
  padding: var(--spacing-3) var(--spacing-1-5) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.qi0EOr {
  align-items: flex-start;
  padding-top: 30px;
}

.QsBBzv {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.M0s9Ki {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: calc(-1 * var(--spacing-0-5));
}

.M0s9Ki img {
  width: 16px;
  height: 16px;
}

.W2Zyom {
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
  flex: 1;
  gap: var(--spacing-2);
  display: flex;
  flex-direction: column;
}

.DM5luH {
  margin: 0;
  min-width: 0;
}

.agU4x0 {
  padding: var(--spacing-3);
  border-top: none;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--spacing-2);
  background: var(--surface-neutral-white);
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
}

.rolnG7 {
  background-color: var(--neutral-dark-opacity-50) !important;
}

.mi9Clh,
.wSSOXG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  text-align: center;
  flex: 1;
}

.N2zX6y {
  width: var(--spacing-9);
  height: var(--spacing-9);
  border-radius: 50%;
  background: rgba(202, 70, 21, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-3);
}

.xgv4JK {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-160);
  margin: 0;
  margin-bottom: var(--spacing-1);
}

.wpIMUp {
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-160);
  margin: 0;
}

.UtywbU .btn {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  padding: var(--spacing-1) var(--spacing-1-5);
  border-radius: var(--radius-s);
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.UtywbU .btn-outline-primary {
  color: var(--text-primary-medium);
  border: 2px solid var(--text-primary-medium);
}

.UtywbU .btn-outline-primary:hover {
  color: var(--text-neutral-white);
  background-color: var(--text-primary-medium);
  border-color: var(--text-primary-medium);
}

.UtywbU .btn-primary {
  background-color: var(--text-primary-medium);
  border-color: var(--text-primary-medium);
  color: var(--text-neutral-white);
}

.UtywbU .btn-primary:hover {
  background-color: var(--text-primary-strong);
  border-color: var(--text-primary-strong);
}

.UtywbU .btn-primary:disabled,
.UtywbU .btn-outline-primary:disabled {
  background-color: var(--disabled-subtle-surface);
  border-color: var(--disabled-subtle-surface);
  color: var(--disabled-subtle-text);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/AddressListModal/AddressListModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,OAAO;EACP,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,mCAAmC;EACnC,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,4CAA4C;EAC5C,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;;EAEE,gDAAgD;EAChD,4CAA4C;EAC5C,kCAAkC;EAClC,mBAAmB;AACrB","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-1-5) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.noNumberWrapper {\n  align-items: flex-start;\n  padding-top: 30px;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: calc(-1 * var(--spacing-0-5));\n}\n\n.backButton img {\n  width: 16px;\n  height: 16px;\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1;\n  gap: var(--spacing-2);\n  display: flex;\n  flex-direction: column;\n}\n\n.alert {\n  margin: 0;\n  min-width: 0;\n}\n\n.modalFooter {\n  padding: var(--spacing-3);\n  border-top: none;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: var(--spacing-2);\n  background: var(--surface-neutral-white);\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.backdrop {\n  background-color: var(--neutral-dark-opacity-50) !important;\n}\n\n.errorContainer,\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  flex: 1;\n}\n\n.errorIcon {\n  width: var(--spacing-9);\n  height: var(--spacing-9);\n  border-radius: 50%;\n  background: rgba(202, 70, 21, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-3);\n}\n\n.errorTitle {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-160);\n  margin: 0;\n  margin-bottom: var(--spacing-1);\n}\n\n.errorDescription {\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-160);\n  margin: 0;\n}\n\n.modalContent :global(.btn) {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border-radius: var(--radius-s);\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.modalContent :global(.btn-outline-primary) {\n  color: var(--text-primary-medium);\n  border: 2px solid var(--text-primary-medium);\n}\n\n.modalContent :global(.btn-outline-primary:hover) {\n  color: var(--text-neutral-white);\n  background-color: var(--text-primary-medium);\n  border-color: var(--text-primary-medium);\n}\n\n.modalContent :global(.btn-primary) {\n  background-color: var(--text-primary-medium);\n  border-color: var(--text-primary-medium);\n  color: var(--text-neutral-white);\n}\n\n.modalContent :global(.btn-primary:hover) {\n  background-color: var(--text-primary-strong);\n  border-color: var(--text-primary-strong);\n}\n\n.modalContent :global(.btn-primary:disabled),\n.modalContent :global(.btn-outline-primary:disabled) {\n  background-color: var(--disabled-subtle-surface);\n  border-color: var(--disabled-subtle-surface);\n  color: var(--disabled-subtle-text);\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `qezDWa`,
	"modalDialog": `t0egR6`,
	"modalContent": `UtywbU`,
	"modalHeader": `WIeLZB`,
	"noNumberWrapper": `qi0EOr`,
	"modalTitle": `QsBBzv`,
	"backButton": `M0s9Ki`,
	"modalBody": `W2Zyom`,
	"alert": `DM5luH`,
	"modalFooter": `agU4x0`,
	"backdrop": `rolnG7`,
	"errorContainer": `mi9Clh`,
	"loadingContainer": `wSSOXG`,
	"errorIcon": `N2zX6y`,
	"errorTitle": `xgv4JK`,
	"errorDescription": `wpIMUp`
};
module.exports = ___CSS_LOADER_EXPORT___;
